
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import ProtectedRoute from '../components/auth/ProtectedRoute';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const CoursePage = lazy(() => import('../pages/course/page'));
const ModulePage = lazy(() => import('../pages/course/module/page'));
const PurchasePage = lazy(() => import('../pages/purchase/page'));
const PurchaseSuccessPage = lazy(() => import('../pages/purchase/success/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const ConsultingPage = lazy(() => import('../pages/consulting/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const RegisterPage = lazy(() => import('../pages/auth/register/page'));
const ForgotPasswordPage = lazy(() => import('../pages/auth/forgot-password/page'));
const ResetPasswordPage = lazy(() => import('../pages/auth/reset-password/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    Component: HomePage,
  },
  {
    path: '/course',
    element: <ProtectedRoute><CoursePage /></ProtectedRoute>,
  },
  {
    path: '/course/module/:moduleId',
    element: <ProtectedRoute><ModulePage /></ProtectedRoute>,
  },
  {
    path: '/purchase',
    Component: PurchasePage,
  },
  {
    path: '/purchase/success',
    element: <ProtectedRoute><PurchaseSuccessPage /></ProtectedRoute>,
  },
  {
    path: '/resources',
    Component: ResourcesPage,
  },
  {
    path: '/consulting',
    Component: ConsultingPage,
  },
  {
    path: '/support',
    Component: SupportPage,
  },
  {
    path: '/faq',
    Component: FAQPage,
  },
  {
    path: '/privacy',
    Component: PrivacyPage,
  },
  {
    path: '/terms',
    Component: TermsPage,
  },
  {
    path: '/auth/login',
    Component: LoginPage,
  },
  {
    path: '/auth/register',
    Component: RegisterPage,
  },
  {
    path: '/auth/forgot-password',
    Component: ForgotPasswordPage,
  },
  {
    path: '/auth/reset-password',
    Component: ResetPasswordPage,
  },
  {
    path: '*',
    Component: NotFoundPage,
  },
];

export default routes;
